import React, { Component } from 'react';
import { LocalizationContext } from 'localization-context';
import SvgClose from '../assets/Close';


const WithContext = (Component) => {
    return (props) => (
        <LocalizationContext.Consumer>
            {value => <Component {...props} localizationContext={value} />}
        </LocalizationContext.Consumer>
    )
}

class RZNotificationDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    onConfirmButtonClicked = (e) => {
        this.props.handleConfirmButtonClicked();
    }

    onCancelButtonClicked = (e) => {
        this.props.handleCancelButtonClicked();
    }

    onSVGCloseClicked = (e)=> {
        this.props.handleCancelButtonClicked();
    }

    render() {
        // let AlexaLogo = theme === themes.light ? AlexaLogoLight : AlexaLogoDark;
        let dialogHeaderContent = this.props.headerContent;
        let dialogTextContent = this.props.textContent;
        let dialogOkTextContent = this.props.okTextContent;
        let dialogCancelTextContent = this.props.cancelTextContent;
        return (
            <div>
                <div className="rzdialog-container">
                    <div className="close">
                        <SvgClose onClick={this.onSVGCloseClicked}/>
                    </div>
                    <div className="rzdialog-wrapper">
                        <div className="alexa-icon-wrapper">
                            {dialogHeaderContent}
                        </div>
                        <div className="rzdialog-content">
                            {dialogTextContent}
                        </div>
                        <div className="button-row">
                            {/* <button className="confirm" onClick={this.onConfirmButtonClicked}>{dialogOkTextContent}</button>
                            <button className="cancel" onClick={this.onCancelButtonClicked}>{dialogCancelTextContent}</button> */}
                            <div className="alexa-btn-gray-overlay" style={{ marginTop: '20px' }} onClick={this.onCancelButtonClicked}>
                                <div className="alexa-btn-gray alexa-flex-column-center"><span className="rzButton">{dialogCancelTextContent}</span></div>
                            </div>
                            <div className="alexa-btn-green-overlay" style={{ marginTop: '20px' }} onClick={this.onConfirmButtonClicked}>
                                <div className="alexa-btn-green alexa-flex-column-center"><span className="rzButton">{dialogOkTextContent}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default WithContext(RZNotificationDialog);;